// extracted by mini-css-extract-plugin
module.exports = {"button":"TypeToggle_button__BZkXZ","underline":"TypeToggle_underline__1V0px","typography":"TypeToggle_typography__m9lCo"};